import styled from 'styled-components';

export const H6 = styled.span(({ theme }) => theme.typography.h6);
export const Body1 = styled.span(({ theme }) => theme.typography.body_1);
export const Body2 = styled.span(({ theme }) => theme.typography.body_2);
export const Input1 = styled.span(({ theme }) => theme.typography.input_1);
export const ButtonText1 = styled.span(
    ({ theme }) => theme.typography.buttonText_1,
);
export const ButtonText2 = styled.span(
    ({ theme }) => theme.typography.buttonText_2,
);

const typographyComponents = {
    H6,
    Body1,
    Body2,
    Input1,
    ButtonText1,
    ButtonText2,
};

export default typographyComponents;
